
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Coach Jennifer Martinez',
      role: 'Push the Rock Academy Head Coach',
      photo: 'https://public.readdy.ai/ai/img_res/0bf0510d56c33cbbd43fd095c6286e84.jpg',
      quote: 'Jazzlyn is one of the most dedicated and coachable athletes I\'ve worked with in my 15 years of coaching. Her work ethic is exceptional, and she consistently demonstrates leadership both on and off the court. She has the physical tools, mental toughness, and volleyball IQ to excel at the collegiate level. Any program would be lucky to have her.',
      rating: 5
    },
    {
      name: 'Coach Michael Thompson',
      role: 'Notre Dame of East Stroudsburg Coach',
      photo: 'https://readdy.ai/api/search-image?query=Professional%20male%20volleyball%20coach%20portrait%2C%20experienced%20demeanor%2C%20coaching%20uniform%2C%20indoor%20sports%20facility%20background%2C%20confident%20expression%2C%20clean%20simple%20background%2C%20professional%20sports%20coaching%20photography&width=400&height=400&seq=coach-portrait-002&orientation=squarish',
      quote: 'Jazzlyn made an immediate impact when she joined our program. Despite being one of the youngest players, she earned a starting position through her exceptional skill and determination. Her defensive abilities and court awareness are impressive, but what really sets her apart is her ability to read the game. She\'s a natural leader who elevates everyone around her.',
      rating: 5
    },
    {
      name: 'Emily Rodriguez',
      role: 'Team Captain &amp; Setter',
      photo: 'https://readdy.ai/api/search-image?query=Young%20female%20volleyball%20player%20portrait%2C%20friendly%20smile%2C%20orange%20and%20white%20team%20uniform%2C%20indoor%20gym%20setting%2C%20teammate%20photo%2C%20positive%20expression%2C%20clean%20simple%20background%2C%20youth%20sports%20photography&width=400&height=400&seq=teammate-portrait-001&orientation=squarish',
      quote: 'Playing with Jazzlyn has made me a better setter. She\'s always in the right position, communicates constantly, and never gives up on a ball. Her positive energy is contagious, and she pushes all of us to be better. She\'s not just a great player—she\'s an amazing teammate and friend.',
      rating: 5
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-purple-50 via-white to-pink-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4">
            TESTIMONIALS
          </h2>
          <div className="w-24 h-2 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full mb-4"></div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            What coaches and teammates say about me
          </p>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="relative">
                  <div className="w-20 h-20 rounded-full overflow-hidden ring-4 ring-purple-500">
                    <img 
                      src={testimonial.photo}
                      alt={testimonial.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center">
                    <i className="ri-double-quotes-r text-white text-xl"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">{testimonial.name}</h3>
                </div>
              </div>
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.quote}"
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-3xl p-12 text-center text-white shadow-2xl">
          <i className="ri-mail-fill text-6xl mb-6"></i>
          <h3 className="text-3xl md:text-4xl font-black mb-4">
            REFERENCES AVAILABLE UPON REQUEST
          </h3>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Additional coaching references and academic recommendations available for serious recruiting inquiries
          </p>
        </div>
      </div>
    </section>
  );
}
